import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { PageHeader, Btn, Field, Input, Select, Modal, Badge } from "@/components/UI";
import { Plus, Trash, User } from "@phosphor-icons/react";

export default function Utenti() {
  const [users, setUsers] = useState([]);
  const [modal, setModal] = useState(false);
  const [form, setForm] = useState({ email: "", password: "", name: "", role: "beneficiario" });

  const load = () => api.get("/users").then((r) => setUsers(r.data));
  useEffect(() => { load(); }, []);

  const create = async () => {
    try {
      await api.post("/auth/register", form);
      setModal(false);
      setForm({ email: "", password: "", name: "", role: "beneficiario" });
      load();
    } catch (e) { alert(e.response?.data?.detail || "Errore"); }
  };

  const del = async (id) => {
    if (!window.confirm("Confermi eliminazione?")) return;
    await api.delete(`/users/${id}`);
    load();
  };

  const tone = (r) => r === "admin" ? "red" : r === "consulente" ? "blue" : "slate";

  return (
    <div className="fade-in" data-testid="utenti-page">
      <PageHeader eyebrow="Amministrazione" title="Gestione Utenti"
        actions={<Btn variant="primary" onClick={() => setModal(true)} data-testid="utenti-new-btn">
          <Plus size={16} weight="bold" /> Nuovo utente
        </Btn>} />

      <div className="p-8">
        <div className="bg-white border border-slate-200 rounded-md overflow-hidden">
          <table className="data-table">
            <thead>
              <tr><th>Utente</th><th>Email</th><th>Ruolo</th><th>Creato</th><th className="w-24">Azioni</th></tr>
            </thead>
            <tbody>
              {users.map((u) => (
                <tr key={u.id} data-testid={`utente-${u.id}`}>
                  <td className="flex items-center gap-3">
                    <div className="w-8 h-8 rounded-full bg-blue-100 text-blue-700 flex items-center justify-center text-sm font-bold">
                      {u.name?.[0]?.toUpperCase()}
                    </div>
                    <span className="font-medium">{u.name}</span>
                  </td>
                  <td className="mono text-xs">{u.email}</td>
                  <td><Badge tone={tone(u.role)}>{u.role}</Badge></td>
                  <td className="text-xs text-slate-500">{u.created_at?.split("T")[0]}</td>
                  <td>
                    <button onClick={() => del(u.id)} className="w-8 h-8 rounded flex items-center justify-center hover:bg-red-50 text-red-600" data-testid={`del-user-${u.id}`}>
                      <Trash size={15} />
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      <Modal open={modal} onClose={() => setModal(false)} title="Nuovo utente" testId="utente-modal">
        <div className="grid grid-cols-2 gap-4">
          <Field label="Nome *"><Input value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} data-testid="utente-name" /></Field>
          <Field label="Ruolo *">
            <Select value={form.role} onChange={(e) => setForm({ ...form, role: e.target.value })} data-testid="utente-role">
              <option value="admin">Admin</option>
              <option value="consulente">Consulente</option>
              <option value="beneficiario">Beneficiario</option>
            </Select>
          </Field>
          <div className="col-span-2"><Field label="Email *"><Input type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} data-testid="utente-email" /></Field></div>
          <div className="col-span-2"><Field label="Password *"><Input type="password" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} data-testid="utente-password" /></Field></div>
          <div className="col-span-2 flex justify-end gap-2 pt-4 border-t border-slate-200">
            <Btn variant="secondary" onClick={() => setModal(false)}>Annulla</Btn>
            <Btn variant="primary" onClick={create} data-testid="utente-save">Crea utente</Btn>
          </div>
        </div>
      </Modal>
    </div>
  );
}
